<template>
  <div class="squadra_info">
    <div class="d-flex pb-4 justify-space-around">
      <div>
        OffertaMax <strong>{{ maxofferta }}</strong>
      </div>
      <div>
        Rimanenti <strong>{{ crediti }}</strong>
      </div>
    </div>
    <div>
      <span
        v-for="ruolo in ruoli_array"
        :key="ruolo"
        class="mx-1"
        :class="{
          'text--disabled': acquistiCompletati(ruolo, id_squadra),
          ['Ruolo onlyLetter Ruolo_' + ruolo]: true,
        }"
        >{{ acquistiPerRuolo(ruolo, id_squadra) }} /
        {{ prefixAcquistabiliPerRuolo() }}
        <span v-html="acquistabiliPerRuolo(ruolo)"></span>
      </span>
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import Vuex from "vuex";

export default {
  name: "squadra-info-panel",
  mixins: [mixins],
  props: {
    id_squadra: {
      type: String || Number,
      required: true,
      default: null,
    },
  },
  mounted() {},
  computed: {
    crediti: function () {
      return this.asta_squadre[this.id_squadra].crediti;
    },
    maxofferta: function () {
      return this.asta_squadre[this.id_squadra].max_offerta;
    },
    ...Vuex.mapGetters(["asta_info", "asta_squadre"]),
  },
};
</script>
<style scoped>
.squadra_info {
  text-align: center;
}
.Ruolo {
  min-width: 54px;
  font-size: 12px !important;
  font-weight: bold;
}
</style>
